
export default {
  name: 'SportsDisplayFormat',
  values: {
    soccer: {
      segment: 'halves',
      score: 'goals',
    },
    handball: {
      segment: 'halves',
      score: 'goals',
    },
    american_football: {
      segment: 'halves',
      score: 'goals',
    },
    rugby_union: {
      segment: 'halves',
      score: 'goals',
    },
    rugby_league: {
      segment: 'halves',
      score: 'goals',
    },
    table_tennis: {
      segment: 'sets',
      score: 'setPoint',
    },
    tennis: {
      segment: 'sets',
      score: 'setGamePoint',
    },
    volleyball: {
      segment: 'sets',
      score: 'setPoint',
    },
    beach_volleyball: {
      segment: 'sets',
      score: 'setPoint',
    },
    badminton: {
      segment: 'sets',
      score: 'setPoint',
    },
    baseball: {
      segment: 'innings',
      score: 'goals',
    },
    basketball: {
      segment: 'quarters',
      score: 'goals',
    },
    ice_hockey: {
      segment: 'periods',
      score: 'goals',
    },
    snooker: {
      segment: 'frames',
    },
    golf: {
      score: 'none',
    },
    cycling: {
      score: 'none',
    },
    motorsport: {
      score: 'none',
    },
  },
  meta: {
    extendable: false,
  },
}
